<mat-accordion multi *ngIf="documentList.length">
  <mat-expansion-panel *ngFor="let doc of documentList; let i = index">
    <mat-expansion-panel-header>
      <mat-panel-title class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <mat-icon class="me-4" style="font-size: 24px">
            <span
              *ngIf="!!doc.files[0] && !doc.files[0]?.isDateUntil"
              [ngClass]="doc?.invalidUntilProperties?.class"
              [matTooltip]="doc?.invalidUntilProperties?.tooltip"
            >
              {{ doc?.invalidUntilProperties?.icon || "" }}
            </span>
          </mat-icon>
          <div class="d-flex flex-column">
            <div class="d-flex align-items-center">
              <span class="me-2">
                {{ doc.description }}
              </span>
              <mat-icon
                *ngIf="isDocumentComplete(doc) || doc.required"
                [ngClass]="
                  isDocumentComplete(doc) ? 'text-success' : 'text-danger'
                "
                class="ml-1"
              >
                {{ isDocumentComplete(doc) ? "check_circle" : "error" }}
              </mat-icon>
            </div>
            <span *ngIf="isDocumentComplete(doc)">
              <span class="text-muted">
                {{
                  doc.type === "PENULTIMO_BALANCO"
                    ? doc?.files?.length + " balanço(s) importado(s)"
                    : doc?.files?.length + " documento(s) importado(s)"
                }}
              </span>
              <span class="text-muted" *ngIf="!!doc?.files[0]?.createdAt"
                >| Data de inclusão: {{ doc.files[0].createdAt }}</span
              >
            </span>
            <span
              *ngIf="!isDocumentComplete(doc) && doc.required"
              class="text-danger"
            >
              {{
                doc.type === "PENULTIMO_BALANCO"
                  ? doc?.files?.length === 1
                    ? "Documento pendente - Falta 1 balanço (envie os últimos)"
                    : "Documento pendente - mínimo 2 balanços"
                  : "Documento pendente - Falta 1 documento"
              }}
            </span>
          </div>
        </div>
        <div>
          <button
            mat-stroked-button
            color="accent"
            (click)="fileInput.click()"
            type="button"
            *ngIf="!doc.isLoading"
          >
            <span>Importar</span>
            <input
              class="d-none"
              type="file"
              #fileInput
              accept=".png, .PNG, .jpg, .JPG, .jpeg, .JPEG, .pdf, .PDF"
              [multiple]="
                doc.type === 'OTHERS' ||
                doc.type === 'PENULTIMO_BALANCO' ||
                doc.type === 'FATURAMENTO'
              "
              (change)="addDocument($event, doc.type, i)"
            />
          </button>
          <button
            mat-flat-button
            class="ml-3 mr-1"
            color="accent"
            *ngIf="doc.isLoading"
            disabled
          >
            IMPORTANDO
            <mat-spinner
              class="d-inline-block ml-3"
              [diameter]="20"
            ></mat-spinner>
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <p
      class="document-file-item d-flex align-items-center mb-2 ps-4"
      *ngFor="let file of doc.files; let j = index"
    >
      <mat-icon class="document-file-bullet">fiber_manual_record</mat-icon>
      <span class="document-file-name ms-1">
        {{ normalizeFileName(file?.name) }}
      </span>
    </p>
  </mat-expansion-panel>
</mat-accordion>
